import type { UserAccess } from '../auth/types'

export type User = {
  id: number
  email: string
  name?: string
  lastName?: string
  access?: UserAccess
  products?: UserProduct[]
  needsTokenRefresh?: boolean
  phone?: string
  phoneCountryCode?: string
  onboardingCompleted: boolean
  shouldCompleteOnboarding: boolean
  linkedinSub?: string
  stripeCustomerId?: string
}

interface UserProduct {
  expiresAt: Date
  productSlug: string
}

export enum EducationLevel {
  STUDYING_BACHELOR = 'STUDYING_BACHELOR',
  STUDYING_MASTER = 'STUDYING_MASTER',
  GRADUATED = 'GRADUATED'
}

export enum QualificationLevel {
  BACHELOR = 'BACHELOR',
  BACHELOR_AND_MASTER = 'BACHELOR_AND_MASTER'
}

export interface UserStudies {
  educationLevel: EducationLevel

  bachelorId: number
  bachelorUniversityId: number
  bachelorStartYear: number

  masterName?: string
  masterUniversityId?: number
  masterEndYear?: number

  doneProfessionalInternships?: boolean
  internshipIndustryId?: number

  isWorking?: boolean
  qualificationLevel?: QualificationLevel
  workingIndustryId?: number
}

export interface UserPreferences {
  userId: number
  optinWhatsapp: boolean
  optinJobOffers: boolean
  phone: string
  phoneCountryCode: string
  knowingProffesionalOportunities: number // 0-5
  knowingCareerGoal: number // 0-5
  goals: UserGoals[]
  favouriteCategories: number[] // cat ids
  favouriteCareerPaths: number[] // ind ids
  onboardingCompleted: boolean
}

export enum UserGoals {
  EXPLORE_JOB_OFFERS = 'EXPLORE_JOB_OFFERS',
  GET_JOB_OFFERS = 'GET_JOB_OFFERS',
  GET_READY_FOR_JOB_OFFERS = 'GET_READY_FOR_JOB_OFFERS'
}

export interface StudentLanguage {
  code: string
  level: number
}

export interface StudentLanguageWithLabels extends StudentLanguage {
  languageName: string
  levelLabel: string
}

export interface StudentLanguageDto {
  code: string
  level: number
}

export interface LanguageOption {
  code: string
  name: string
}

export interface LanguageLevelOption {
  level: number
  label: string
}

export interface UserLanguagesResponse {
  items: StudentLanguageWithLabels[]
  languages: LanguageOption[]
  levels: LanguageLevelOption[]
}

export interface UserCv {
  id: number
  srcUrl: string
  cvQuality?: string
  pointsOfImprovement?: string[]
  requiresPremiumForAnalysis?: boolean
}

export interface UserAcademicTranscript {
  id: number
  srcUrl: string
  s3Key?: string
}
